import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTierPricePoint.BulkUpdateProductTierPricePoints.IRequest;
type Headers = Api.Core.ProductTierPricePoint.BulkUpdateProductTierPricePoints.IHeaders;
type Response = Api.Core.ProductTierPricePoint.BulkUpdateProductTierPricePoints.IResponse;
const url = '/api/ProductManagement/ProductTierPricePoint/BulkUpdateProductTierPricePoints';
export async function bulkUpdateProductTierPricePointsApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
